import React from 'react'
import styled from 'styled-components';
import Up from "../assets/up.svg"
import { Link,useStaticQuery, graphql } from "gatsby"
import BackgroundImage from "gatsby-background-image"

const getImage = graphql`
  query {
    defaultBcg: file(relativePath: { eq: "footer-bg-1.png" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 2600) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

  }
`

const FooterTop = () => {
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
    const data = useStaticQuery(getImage)
    return (
        
        <Wrapper>
            <BackgroundImage fluid={data.defaultBcg.childImageSharp.fluid}>
        <div className="footer-top">
        <h2>Ready to get started?</h2>
        <div className="buttons">
          
          <Link
            to="/contact/"
            className="btn btn-main"
            style={{ marginRight: "3rem" }}
          >
            Get Started
          </Link>
          <Link to="#" className="btn btn-foot2">
            Take the tour
          </Link>
        </div>

        <button onClick={scrollTop} className="up-btn">
          <img src={Up} alt="Go top" />
        </button>
        </div>
        </BackgroundImage>
      </Wrapper>
      
    )
}

const Wrapper = styled.div`
.footer-top {
    position: relative;
    padding: 60px 20px;
  }
  @media screen and (min-width: 1025px) {
      width: 93vw;
      max-width: 1360px;
      margin: 0 auto 100px;
      border-radius: 30px;
    }
  background: var(--clr-primary-1); 
  
  position: relative; 
  

  h2 { font-size: 28px; line-height: 44px; color: var(--clr-white); }

  .buttons {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    a{ margin-bottom: 28px;}
    @media screen and (min-width: 568px) { width: 60%; margin: 2rem auto; }
    @media screen and (min-width: 768px) { width: 40%; }
    @media screen and (min-width: 1024px) { flex-direction: row; width: 570px; a{ margin-bottom: 0px;} }
  }

  .btn { width: 100%; display: block; }

  .up-btn { background: none; border: none; cursor: pointer; position: absolute; right: 1%; bottom: 2%;
    @media screen and (min-width: 1025px) {opacity: 0.1;}
    @media screen and (min-width: 1024px) { right: 5%; bottom: 10%; }
    :focus { outline: 0; }

  }

  .btn-foot2 {
    :hover { border: 1px solid white; }
  }
`;
export default FooterTop
